import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError, map, retry, shareReplay } from 'rxjs/operators';
import { BaseService, CommonService, ModuleConfig, ModuleConfigService, OrganizationInfo, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class AppOrganizationService extends BaseService {
    readonly ORGANIZATION_INFO_KEY = 'organization_info';
    readonly RETRY_COUNT: number = 0;
    readonly REPLAY_COUNT: number = 10;

    readonly organizationEndpoint: any;
    readonly _moduleConfig: ModuleConfig;
    private injector: Injector;

    constructor(
        http: HttpClient,
        injector: Injector,
        _moduleConfigService: ModuleConfigService
    ) {
        super(http, injector, `${_moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint}/AppOrganization`);
        this.endPoint = _moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint;

        this._moduleConfig = _moduleConfigService.getConfig();
        this.injector = injector;
    }

    setNguoiDaiDien(organizationId: any, idCanBo?: any) {
        let apiUrl = `${this.serviceUri}/SetNguoiDaiDien/${organizationId}`;

        if (idCanBo) {
            apiUrl = `${apiUrl}/${idCanBo}`;
        }

        return this.defaultPut(apiUrl, null);
    }

    getOrganizationInfo(organizationId: number): Promise<OrganizationInfo> {
        const storageItem = localStorage.getItem(this.ORGANIZATION_INFO_KEY + '_' + organizationId);
        const organization = <OrganizationInfo>JSON.parse(storageItem);
        if (organization) {
            return new Promise((resolve, reject) => resolve(organization));
        } else {
            return new Promise(async (resolve, reject) => {
                if (organizationId == null) {
                    reject(<OrganizationInfo>{});
                } else {
                    if (organizationId > 0) {
                        const svUrl = `${this.serviceUri}/GetOrganizationInfo?id=${organizationId}`;
                        const result = await this._http.get<ResponseResult>(svUrl).pipe(
                            shareReplay(this.REPLAY_COUNT),
                            retry(this.RETRY_COUNT),
                            map(repsonse => {
                                // save response to local storage here
                                localStorage.setItem(this.ORGANIZATION_INFO_KEY + '_' + repsonse.data.id, JSON.stringify(repsonse.data));
                                return <OrganizationInfo>repsonse.data;
                            },
                                catchError((err: HttpErrorResponse) => this.handleError(err, this._injector))
                            )).toPromise();

                        resolve(result);
                    }
                }
            });
        }
    }

    handleError(error: any, injector: Injector) {
        const commonService = injector.get(CommonService);
        return commonService.handleError(error, injector);
    }

    getStaffInOrganization(organizationId: any) {
        const apiUrl = `${this.serviceUri}/GetStaffInOrganization`;

        return this.defaultGet(apiUrl);
    }

    getByParentId(parentId?: number, litmit?: number): Promise<ResponseResult> {
        let svUrl = `${this.serviceUri}/?limit=${litmit}`;
        if (parentId) {
            svUrl += `&parentId=${parentId}`;
        }

        return this._http.get<ResponseResult>(svUrl).pipe(
            shareReplay(this.REPLAY_COUNT),
            retry(this.RETRY_COUNT),
            catchError((err: HttpErrorResponse) => this.handleError(err, this.injector))
        ).toPromise();
    }

    getById(id: number): Promise<ResponseResult> {
        const svUrl = `${this.serviceUri}/${id}`;

        return this._http.get<ResponseResult>(svUrl).pipe(
            shareReplay(this.REPLAY_COUNT),
            retry(this.RETRY_COUNT),
            catchError((err: HttpErrorResponse) => this.handleError(err, this.injector))
        ).toPromise();
    }

    // tslint:disable-next-line: adjacent-overload-signatures
    getOrganizationTree(organizationCode?: any): Promise<ResponseResult> {
        let apiUrl = `${this.serviceUri}/GetTree`;

        if (organizationCode) {
            apiUrl = `${apiUrl}?organizationCode=${organizationCode}`;
        }

        return this._http.get<ResponseResult>(apiUrl)
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this.injector)))
            .toPromise();
    }

    getOrganizationTreeById(organizationId?: any): Promise<ResponseResult> {
        let apiUrl = `${this.serviceUri}/GetTreeById`;

        if (organizationId) {
            apiUrl = `${apiUrl}?organizationId=${organizationId}`;
        }

        return this._http.get<ResponseResult>(apiUrl)
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this.injector)))
            .toPromise();
    }

    getOrganizationTreeTable(key?: any, site?: any, isIgnoreClientCache: boolean = false): Promise<ResponseResult> {
        const apiUrl = `${this.serviceUri}/GetTreeTable?key=${key}&site=${site}`;

        if (isIgnoreClientCache) {
            return this.getIgnoreClientCache(apiUrl);
        }
        return this.defaultGet(apiUrl);
    }

    getByParentCode(organizationCode?: any): Promise<ResponseResult> {
        let apiUrl = `${this.serviceUri}/GetByParentCode`;

        if (organizationCode) {
            apiUrl = `${apiUrl}?parentCode=${organizationCode}`;
        }

        return this._http.get<ResponseResult>(apiUrl)
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this.injector)))
            .toPromise();
    }
    getManagerByOrgCode(organizationCode?: any): Promise<ResponseResult> {
        const apiUrl = `${this.serviceUri}/GetManagerByOrgCode/${organizationCode}`;
        return this._http.get<ResponseResult>(apiUrl)
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this.injector)))
            .toPromise();
    }
    getManagerByOrgId(organizationId?: any): Promise<ResponseResult> {
        const apiUrl = `${this.serviceUri}/GetManagerByOrgId/${organizationId}`;
        return this._http.get<ResponseResult>(apiUrl)
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this.injector)))
            .toPromise();
    }


    getOrganizationByParentId(parentId: number): Promise<ResponseResult> {
        const apiUrl = `${this.serviceUri}/GetByParentId?parentId=${parentId}`;
        return this._http.get<ResponseResult>(apiUrl)
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this.injector)))
            .toPromise();
    }

}
